import { SegmentedOption } from '../SegmentedControl/SegmentedControl';

export type ViewMode = 'compact' | 'detailed';

export const VIEW_MODE_OPTIONS: SegmentedOption[] = [
  { val: 'compact', label: 'Compact View' },
  { val: 'detailed', label: 'Detailed View' },
];

export const VIEW_MODE_COLOR_SCHEME = {
  compact: { bg: '#D12929', text: 'text-white', glow: 'shadow-[0_0_6px_#D1292988]' },
  detailed: { bg: '#D12929', text: 'text-white', glow: 'shadow-[0_0_6px_#D1292988]' },
};

// Top-level grouping for the Report View: list devices, or list patches applied across devices.
export type ReportViewMode = 'device' | 'patch';

export const REPORT_VIEW_MODE_OPTIONS: SegmentedOption[] = [
  { val: 'device', label: 'Device View' },
  { val: 'patch', label: 'Patch View' },
];

export const REPORT_VIEW_MODE_COLOR_SCHEME = {
  device: { bg: '#D12929', text: 'text-white', glow: 'shadow-[0_0_6px_#D1292988]' },
  patch: { bg: '#D12929', text: 'text-white', glow: 'shadow-[0_0_6px_#D1292988]' },
};

// Statuses shown when a table is toggled to Compact view.
export const COMPACT_VIEW_STATUSES = ['NotSubmitted', 'NotStarted', 'Completed', 'InProgress', 'CompletedWithErrors', 'Unknown', 'Offline'];

export const isCompactVisibleStatus = (status?: string | null): boolean => {
  if (!status) return false;
  return COMPACT_VIEW_STATUSES.some((s) => s.toLowerCase() === status.toLowerCase());
};
